import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';

import LandingPage from './pages/LandingPage';
import LoginPage from './pages/LoginPage';
import SignupPage from './pages/SignupPage';
import AdminDashboard from './pages/AdminDashboard';
import ClinicianLoginPage from './pages/ClinicianLoginPage';
import ClinicianPortal from './pages/ClinicianPortal';
import ApplyPage from './pages/ApplyPage';
import CrisisPage from './pages/CrisisPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import RequireAdmin from './components/auth/RequireAdmin';
import RequireClinician from './components/auth/RequireClinician';
import { AuthProvider } from './context/AuthContext';

// Opt into the v7 behaviours now: state updates wrapped in startTransition, and
// v7 relative-path resolution inside splat routes. Both are what react-router
// will do by default anyway, and enabling them silences the upgrade warnings.
const ROUTER_FUTURE = { v7_startTransition: true, v7_relativeSplatPath: true };

/**
 * The aurora field behind every glass surface. Fixed and pointer-events:none,
 * so it costs nothing on scroll.
 */
function AuroraBackdrop() {
  return (
    <div className="mm-aurora" aria-hidden="true">
      <span className="mm-aurora__blob mm-aurora__blob--1" />
      <span className="mm-aurora__blob mm-aurora__blob--2" />
      <span className="mm-aurora__blob mm-aurora__blob--3" />
      <span className="mm-aurora__blob mm-aurora__blob--4" />
    </div>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter future={ROUTER_FUTURE}>
        <AuroraBackdrop />

        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/signup" element={<SignupPage />} />
          {/* RequireAdmin only controls rendering; the API re-checks the role
              on every admin request. See RequireAdmin's note. */}
          <Route
            path="/admin"
            element={
              <RequireAdmin>
                <AdminDashboard />
              </RequireAdmin>
            }
          />
          {/* Clinicians get their own door. There is no signup route: portal
              accounts are provisioned after verification, never self-serve. */}
          <Route path="/apply" element={<ApplyPage />} />
          <Route path="/crisis" element={<CrisisPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route path="/clinician/login" element={<ClinicianLoginPage />} />
          <Route
            path="/clinician"
            element={
              <RequireClinician>
                <ClinicianPortal />
              </RequireClinician>
            }
          />
          {/* No 404 page in this build — anything unknown goes home. */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
